module.exports = __webpack_public_path__ + "img/brightdot.f89bad24.png";